import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IniError} from '../../../../../../common/shared/ini-player/IniError.interface';
import {
  VIDEO_VIEWER_SLICE_NAME,
  VideoStatus,
} from '../constant/videoViewerConstant';

import {storeMuteToSessionStorage} from '../util/videoPlayerSessionStorage';
import {VideoState, VideoViewerState} from './VideoViewerState.interface';

const INITIAL_VIDEO_STATE = {
  videoStatus: VideoStatus.BeforeInitialPlay,
  isMute: true,
  // 모바일은 고정 1로 들어가므로 PC 디폴트 값 0.5를 넣어줍니다
  volume: 0.5,
  isFullScreen: false,
  isLoading: false,
};

const INITIAL_VIDEO_VIEWER_STATE: VideoViewerState = {
  videoState: INITIAL_VIDEO_STATE,
  fullscreenEnabled: true,
  showControlBox: false,
  isHovered: false,
  isSeeking: false,
};

export const videoViewerSlice = createSlice({
  name: VIDEO_VIEWER_SLICE_NAME,
  initialState: INITIAL_VIDEO_VIEWER_STATE,
  reducers: {
    clearVideoViewerData: (state, action: PayloadAction<number>) => {
      state.videoState = INITIAL_VIDEO_VIEWER_STATE.videoState;
      state.iniError = undefined;
      state.showControlBox = true;
      state.fullscreenEnabled = true;
    },
    resetVideoState: state => {
      state.videoState = INITIAL_VIDEO_STATE;
    },
    setVideoState: (state, action: PayloadAction<Partial<VideoState>>) => {
      state.videoState = {
        ...state.videoState,
        ...action.payload,
      };
      if ('isMute' in action.payload) {
        storeMuteToSessionStorage(action.payload.isMute as boolean);
      }
    },
    setIniError: (state, action: PayloadAction<IniError>) => {
      state.iniError = action.payload;
    },
    clearIniError: state => {
      state.iniError = undefined;
    },
    setShowControlBox: (state, action: PayloadAction<boolean>) => {
      state.showControlBox = action.payload;
    },
    setIsHovered: (state, action: PayloadAction<boolean>) => {
      state.isHovered = action.payload;
    },
    setIsFullscreenEnabled: (state, action: PayloadAction<boolean>) => {
      state.fullscreenEnabled = action.payload;
    },
    setIsSeeking: (state, action: PayloadAction<boolean>) => {
      state.isSeeking = action.payload;
    },
  },
});

export const {
  clearVideoViewerData,
  setVideoState,
  resetVideoState,
  setIniError,
  clearIniError,
  setShowControlBox,
  setIsHovered,
  setIsFullscreenEnabled,
  setIsSeeking,
} = videoViewerSlice.actions;
